
import React, { Component, PureComponent } from 'react';
import ReactDOM from 'react-dom';

class CarTab extends PureComponent {

  onClick = () => {
    const { label, order, onClick } = this.props;
    onClick(order);
  }

  render() {
    const {
      onClick,
      props: {
        activeTab,
        label,
        order
      },
    } = this;

    let className = 'tab-list-item';

    if (activeTab === order) {
      className += ' tab-list-active';
    }

    return (
      <li
        className={className}
        tabIndex='0'
        onKeyDown = {(e)=> e.key === 'Enter' && onClick()}
      >
        <h3 className="tab-title" onClick={onClick}>{label}</h3>
        {this.props.children}
      </li>
    );
  }
}

export default CarTab;
